<template>
<div class="animated fadeIn">
  <div class="row">
    <div class="col-sm-6 col-lg-3">
      <div class="card">
        <div class="card-body p-3 d-flex align-items-center">
          <i class="fa fa-industry highlight-icon bg-primary p-3 font-2xl mr-3"></i>
          <div>
            <div class="card-text text-dark ">Allocated Warehouse Space </div>
            <strong>10</strong>
          </div>
        </div>
      </div>

    </div>
    <!--/.col-->
    <div class="col-sm-6 col-lg-3">

      <div class="card">
        <div class="card-body p-3 d-flex align-items-center">
          <i class="fa fa-cube highlight-icon bg-success p-3 font-2xl mr-3"></i>
          <div>
            <div class="card-text text-dark ">Allocated Warehouse Space (In sqft)</div>
            <strong>4456</strong>
          </div>
        </div>
      </div>
    </div>
    <!--/.col-->
    <div class="col-sm-6 col-lg-3">
      <div class="card">
        <div class="card-body p-3 d-flex align-items-center">
          <i class="fa fa-shopping-bag highlight-icon bg-warning p-3 font-2xl mr-3"></i>
          <div>
            <div class="card-text text-dark ">Inventory</div>
            <strong>4417.55 (Cubic Meter)</strong>
          </div>
        </div>
      </div>
    </div>
    <!--/.col-->

    <div class="col-sm-6 col-lg-3">
      <div class="card">
        <div class="card-body p-3 d-flex align-items-center">
          <i class="fa fa-truck highlight-icon bg-danger p-3 font-2xl mr-3"></i>
          <div>
            <div class="card-text text-dark ">Orders Shipped</div>
            <strong>(In sqft)</strong>
            <!--div class="text-muted text-uppercase font-weight-bold small">(In sqft)</div-->
          </div>
        </div>
      </div>

    </div>
    <!--/.col-->
  </div>
  <!--/.row-->




  <div class="row">
    <div class="col-sm-6 col-lg-3">
      <div class="card">
        <div class="card-body p-3 d-flex align-items-center">
          <i class="fa fa-cart-plus highlight-icon bg-info p-3 font-2xl mr-3"></i>
          <div>
            <div class="card-text text-dark ">Process Orders</div>
            <strong>34</strong>
          </div>
        </div>
      </div>

    </div>
    <!--/.col-->
    <div class="col-sm-6 col-lg-3">

      <div class="card">
        <div class="card-body p-3 d-flex align-items-center">
          <i class="fa fa-shopping-cart highlight-icon bg-warning p-3 font-2xl mr-3"></i>
          <div>
            <div class="card-text text-dark ">Total Sale</div>
            <strong>370</strong>
            <div class="text-muted text-uppercase font-weight-bold small"></div>
          </div>
        </div>
      </div>


    </div>
    <!--/.col-->
    <div class="col-sm-6 col-lg-3">
      <div class="card">
        <div class="card-body p-3 d-flex align-items-center">
          <i class="fa fa-shopping-cart highlight-icon bg-danger p-3 font-2xl mr-3"></i>
          <div>
            <div class="card-text text-dark ">Total Sale</div>
            <strong>99000.00</strong>
            <div class="text-muted text-uppercase font-weight-bold small"></div>
          </div>
        </div>
      </div>

    </div>
    <!--/.col-->
    <div class="col-sm-6 col-lg-3">
      <div class="card">
        <div class="card-body p-3 d-flex align-items-center">
          <i class="fa fa-rupee highlight-icon bg-success p-3 font-2xl mr-3"></i>
          <div>
            <div class="card-text text-dark ">Total Revenue</div>
            <strong>140500.80</strong>
            <div class="text-muted text-uppercase font-weight-bold small"></div>
          </div>
        </div>
      </div>

    </div>
    <!--/.col-->
  </div>
  <!--/.row-->



  <div class="row">
    <div class="col-sm-6 col-lg-3">

      <!--/.social-box-->
    </div>
    <!--/.col-->
    <div class="col-sm-6 col-lg-3">

      <!--/.social-box-->
    </div>
    <!--/.col-->
    <div class="col-sm-6 col-lg-3">

      <!--/.social-box-->
    </div>
    <!--/.col-->
    <div class="col-sm-6 col-lg-3">

      <!--/.social-box-->
    </div>
    <!--/.col-->
  </div>
  <!--/.row-->




  <div class="row">
    <div class="col-md-12">
      <div class="row">


        <div class="col-lg-6 mb-4">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title mb-4">Top Selling Product</h5>
              <table class="table tbl " style="overflow-x:auto;">
                <thead>
                  <tr class="text-primary">
                    <th>#</th>
                    <th>Product Name</th>
                    <th>Brand</th>
                    <th>Category</th>

                    <th>MRP</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="table">
                    <th scope="row"><img src="static/img/avatars/1111.jpg" style="width:70px;height:70px"></th>
                    <td>Navy Patch Pocket Pants</td>
                    <td>Minikid House
                    </td>
                    <td>Clothes &amp; Shoes</td>

                    <td>2099.00</td>

                  </tr>
                  <tr class="table">
                    <th scope="row"><img src="static/img/avatars/1111.jpg" style="width:70px;height:70px"></th>
                    <td>Navy Patch Pocket Pants</td>
                    <td>Minikid House
                    </td>
                    <td>Clothes &amp; Shoes</td>

                    <td>2099.00</td>

                  </tr>
                  <tr class="table">
                    <th scope="row"><img src="static/img/avatars/1111.jpg" style="width:70px;height:70px"></th>
                    <td>Blue Washed Casual Jeans</td>
                    <td>Minikid House
                    </td>
                    <td>Clothes &amp; Shoes</td>


                    <td>2099.00</td>

                  </tr>
                  <tr class="table">
                    <th scope="row"><img src="static/img/avatars/1111.jpg" style="width:70px;height:70px"></th>
                    <td>Blue Washed Casual Jeans</td>
                    <td>Minikid House
                    </td>
                    <td>Clothes &amp; Shoes</td>

                    <td>2099.00</td>

                  </tr>
                  <tr class="table">
                    <th scope="row"><img src="static/img/avatars/gdg234.jpg" style="width:70px;height:70px"></th>
                    <td>Grasshopper Glow In Dark Half Sleeve T-Shirt - Printed</td>
                    <td>Grasshopper Juniors
                    </td>
                    <td>Clothes &amp; Shoes</td>

                    <td>299.00</td>

                  </tr>
                  <tr class="table">
                    <th scope="row"><img src="static/img/avatars/2222a.jpg" style="width:70px;height:70px"></th>
                    <td>Zero Vests Sleeveless - Set Of 3</td>
                    <td>Zero
                    </td>
                    <td>Clothes &amp; Shoes</td>

                    <td>180.00</td>

                  </tr>
                  <tr class="table">
                    <th scope="row"><img src="static/img/avatars/2222a.jpg" style="width:70px;height:70px"></th>
                    <td>Zero Vests Sleeveless - Set Of 3</td>
                    <td>Zero
                    </td>
                    <td>Clothes &amp; Shoes</td>

                    <td>180.00</td>

                  </tr>
                  <tr class="table">
                    <th scope="row"><img src="static/img/avatars/2222a.jpg" style="width:70px;height:70px"></th>
                    <td>Zero Vests Sleeveless - Set Of 3</td>
                    <td>Zero
                    </td>
                    <td>Clothes &amp; Shoes</td>

                    <td>180.00</td>

                  </tr>
                  <tr class="table">
                    <th scope="row"><img src="static/img/avatars/2222a.jpg" style="width:70px;height:70px"></th>
                    <td>Zero Vests Sleeveless - Set Of 3</td>
                    <td>Zero
                    </td>
                    <td>Clothes &amp; Shoes</td>

                    <td>180.00</td>

                  </tr>
                  <tr class="table">
                    <th scope="row"><img src="static/img/avatars/2222a.jpg" style="width:70px;height:70px"></th>
                    <td>Zero Vests Sleeveless - Set Of 3</td>
                    <td>Zero
                    </td>
                    <td>Clothes &amp; Shoes</td>

                    <td>180.00</td>

                  </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>



        <div class="col-lg-6 mb-4">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title mb-4">Top Selling Product Brandwise</h5>
              <table class="table tbl" style="overflow-x:auto;">
                <thead>
                  <tr class="text-primary">
                    <th>#</th>
                    <th>Product Name</th>
                    <th>Brand</th>
                    <th>Category</th>

                    <th>MRP</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="table">
                    <th scope="row"><img src="static/img/avatars/1111.jpg" style="width:70px;height:70px"></th>
                    <td>Blue Washed Casual Jeans</td>
                    <td>Minikid House
                    </td>
                    <td>Minikid House
                    </td>

                    <td>2099.00</td>

                  </tr>
                  <tr class="table">
                    <th scope="row"><img src="static/img/avatars/1111.jpg" style="width:70px;height:70px"></th>
                    <td>Blue Washed Casual Jeans</td>
                    <td>Minikid House
                    </td>
                    <td>Minikid House
                    </td>

                    <td>2099.00</td>

                  </tr>
                  <tr class="table">
                    <th scope="row"><img src="static/img/avatars/1111.jpg" style="width:70px;height:70px"></th>
                    <td>Navy Patch Pocket Pants</td>
                    <td>Minikid House
                    </td>
                    <td>Minikid House
                    </td>

                    <td>2099.00</td>

                  </tr>
                  <tr class="table">
                    <th scope="row"><img src="static/img/avatars/1111.jpg" style="width:70px;height:70px"></th>
                    <td>Navy Patch Pocket Pants</td>
                    <td>Minikid House
                    </td>
                    <td>Minikid House
                    </td>

                    <td>2099.00</td>

                  </tr>
                  <tr class="table">
                    <th scope="row"><img src="static/img/avatars/421207a.jpg" style="width:70px;height:70px"></th>
                    <td>Lavender Smocked Strappy Bow Dress</td>
                    <td>Place
                    </td>
                    <td>Clothes &amp; Shoes</td>

                    <td>749.00</td>

                  </tr>
                  <tr class="table">
                    <th scope="row"><img src="static/img/avatars/421207a.jpg" style="width:70px;height:70px"></th>
                    <td>Lavender Smocked Strappy Bow Dress</td>
                    <td>Place
                    </td>
                    <td>Clothes &amp; Shoes</td>

                    <td>749.00</td>

                  </tr>
                  <tr class="table">
                    <th scope="row"><img src="static/img/avatars/421207a.jpg" style="width:70px;height:70px"></th>
                    <td>Lavender Smocked Strappy Bow Dress</td>
                    <td>Place
                    </td>
                    <td>Clothes &amp; Shoes</td>

                    <td>749.00</td>

                  </tr>
                  <tr class="table">
                    <th scope="row"><img src="static/img/avatars/421207a.jpg" style="width:70px;height:70px"></th>
                    <td>Smocked Strappy Bow Dress - Orange</td>
                    <td>Place
                    </td>
                    <td>Clothes &amp; Shoes</td>

                    <td>749.00</td>

                  </tr>
                  <tr class="table">
                    <th scope="row"><img src="static/img/avatars/421207a.jpg" style="width:70px;height:70px"></th>
                    <td>Smocked Strappy Bow Dress - Orange</td>
                    <td>Place
                    </td>
                    <td>Clothes &amp; Shoes</td>

                    <td>749.00</td>

                  </tr>
                  <tr class="table">
                    <th scope="row"><img src="static/img/avatars/421207a.jpg" style="width:70px;height:70px"></th>
                    <td>Smocked Strappy Bow Dress - Orange</td>
                    <td>Place
                    </td>
                    <td>Clothes &amp; Shoes</td>

                    <td>749.00</td>

                  </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>


        <div class="col-lg-6 mb-4">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title mb-4">Top Selling Product Categorywise</h5>
              <table class="table table-hover">
                <thead>
                  <tr class="">
                    <th>#</th>
                    <th>Product Name</th>
                    <th>Brand</th>
                    <th>Category</th>

                    <th>MRP</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>

                    <th scope="row"><img src="static/img/avatars/san11.jpg" style="width:70px;height:70px"></th>
                    <td>Doink - Sandals With Floral Applique</td>
                    <td>Doink
                    </td>
                    <td>Clothes &amp; Shoes</td>

                    <td>899.00</td>

                  </tr>
                  <tr>

                    <th scope="row"><img src="static/img/avatars/421207a.jpg" style="width:70px;height:70px"></th>
                    <td>Smocked Strappy Bow Dress - Orange</td>
                    <td>Place
                    </td>
                    <td>Clothes &amp; Shoes</td>

                    <td>749.00</td>

                  </tr>
                  <tr>

                    <th scope="row"><img src="static/img/avatars/421207a.jpg" style="width:70px;height:70px"></th>
                    <td>Lavender Smocked Strappy Bow Dress</td>
                    <td>Place
                    </td>
                    <td>Clothes &amp; Shoes</td>

                    <td>749.00</td>

                  </tr>
                  <tr>

                    <th scope="row"><img src="static/img/avatars/421207a.jpg" style="width:70px;height:70px"></th>
                    <td>Smocked Strappy Bow Dress - Orange</td>
                    <td>Place
                    </td>
                    <td>Clothes &amp; Shoes</td>

                    <td>749.00</td>

                  </tr>
                  <tr>

                    <th scope="row"><img src="static/img/avatars/32aaa.jpg" style="width:70px;height:70px"></th>
                    <td>The Red Rose By Chu Jian Ou - LL131037</td>
                    <td>Posterboy
                    </td>
                    <td>Home Decor</td>

                    <td>2100.00</td>

                  </tr>
                  <tr>

                    <th scope="row"><img src="static/img/avatars/2345gdfg.jpg" style="width:70px;height:70px"></th>
                    <td>CasaMia Air Freshener - Rose</td>
                    <td>CasaMia
                    </td>
                    <td>Home Decor</td>

                    <td>129.00</td>

                  </tr>
                  <tr>

                    <th scope="row"><img src="static/img/avatars/32aaa.jpg" style="width:70px;height:70px"></th>
                    <td>Peaceful Sleep By Chujian Ou - LL131036</td>
                    <td>Posterboy
                    </td>
                    <td>Home Decor</td>

                    <td>925.00</td>

                  </tr>
                  <tr>

                    <th scope="row"><img src="static/img/avatars/dgd2112.jpg" style="width:70px;height:70px"></th>
                    <td>The Conversation By Pam Powell - LL130127</td>
                    <td>Posterboy
                    </td>
                    <td>Home Decor</td>

                    <td>575.00</td>

                  </tr>
                  <tr>

                    <th scope="row"><img src="static/img/avatars/dgd2112.jpg" style="width:70px;height:70px"></th>
                    <td>Mending The Drift By Dix Baines - LL130539</td>
                    <td>Posterboy
                    </td>
                    <td>Home Decor</td>

                    <td>575.00</td>

                  </tr>
                  <tr>

                    <th scope="row"><img src="static/img/avatars/2345gdfg.jpg" style="width:70px;height:70px"></th>
                    <td>CasaMia Air Freshener - Alpine</td>
                    <td>CasaMia
                    </td>
                    <td>Home Decor</td>

                    <td>129.00</td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-lg-6 mb-4">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title mb-4">Top Selling Product SubCategorywise</h5>
              <table class="table">
                <thead>
                  <tr class="text-primary">
                    <th>#</th>
                    <th>Product Name</th>
                    <th>Brand</th>
                    <th>Sub Category</th>

                    <th>MRP</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>

                    <th scope="row"><img src="static/img/avatars/san11.jpg" style="width:70px;height:70px"></th>
                    <td>Doink - Sandals With Floral Applique</td>
                    <td>Doink
                    </td>
                    <td>Clothes &amp; Shoes</td>

                    <td>899.00</td>
                  </tr>
                  <tr>

                    <th scope="row"><img src="static/img/avatars/421207a.jpg" style="width:70px;height:70px"></th>
                    <td>Lavender Smocked Strappy Bow Dress</td>
                    <td>Place
                    </td>
                    <td>Clothes &amp; Shoes</td>

                    <td>749.00</td>
                  </tr>
                  <tr>

                    <th scope="row"><img src="static/img/avatars/421207a.jpg" style="width:70px;height:70px"></th>
                    <td>Smocked Strappy Bow Dress - Orange</td>
                    <td>Place
                    </td>
                    <td>Clothes &amp; Shoes</td>

                    <td>749.00</td>
                  </tr>
                  <tr>

                    <th scope="row"><img src="static/img/avatars/421207a.jpg" style="width:70px;height:70px"></th>
                    <td>Smocked Strappy Bow Dress - Orange</td>
                    <td>Place
                    </td>
                    <td>Clothes &amp; Shoes</td>

                    <td>749.00</td>
                  </tr>
                  <tr>

                    <th scope="row"><img src="static/img/avatars/345aa.jpg" style="width:70px;height:70px"></th>
                    <td>Djeco Princess Marguerite - Bamboo Umbrella</td>
                    <td>Djeco
                    </td>
                    <td>Fashion Accessories</td>

                    <td>1699.00</td>
                  </tr>
                  <tr>

                    <th scope="row"><img src="static/img/avatars/fgd2342.jpg" style="width:70px;height:70px"></th>
                    <td>Palmer's Nursing Cream with Pack of 4 Nursing Pads</td>
                    <td>Palmer's
                    </td>
                    <td>Moms &amp; Maternity</td>

                    <td>2701.00</td>
                  </tr>
                  <tr>

                    <th scope="row"><img src="static/img/avatars/345aa.jpg" style="width:70px;height:70px"></th>
                    <td>Neat-Oh! Dinosaur Carry Case Playmat</td>
                    <td>Neat-Oh!
                    </td>
                    <td>Nursery</td>

                    <td>999.00</td>
                  </tr>
                  <tr>

                    <th scope="row"><img src="static/img/avatars/dgd2112.jpg" style="width:70px;height:70px"></th>
                    <td>The Conversation By Pam Powell - LL130127</td>
                    <td>Posterboy
                    </td>
                    <td>Home Decor</td>

                    <td>575.00</td>
                  </tr>
                  <tr>

                    <th scope="row"><img src="static/img/avatars/dgd2112.jpg" style="width:70px;height:70px"></th>
                    <td>Scouting The Hatch By Dix Baines - LL130538</td>
                    <td>Posterboy
                    </td>
                    <td>Home Decor</td>

                    <td>575.00</td>
                  </tr>
                  <tr>

                    <th scope="row"><img src="static/img/avatars/dgd2112.jpg" style="width:70px;height:70px"></th>
                    <td>Mending The Drift By Dix Baines - LL130539</td>
                    <td>Posterboy
                    </td>
                    <td>Home Decor</td>

                    <td>575.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--/.col-->
  </div>
  <!--/.row-->
</div>
</template>

<script>
import CardLine1ChartExample from './dashboard/CardLine1ChartExample'
import CardLine2ChartExample from './dashboard/CardLine2ChartExample'
import CardLine3ChartExample from './dashboard/CardLine3ChartExample'
import CardBarChartExample from './dashboard/CardBarChartExample'
import MainChartExample from './dashboard/MainChartExample'
import SocialBoxChartExample from './dashboard/SocialBoxChartExample'
import {
  Callout
} from '../components/'

export default {
  name: 'dashboard',
  components: {
    Callout,
    CardLine1ChartExample,
    CardLine2ChartExample,
    CardLine3ChartExample,
    CardBarChartExample,
    MainChartExample,
    SocialBoxChartExample
  },



  methods: {
    variant(value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/merchantdashboard.vue?2eb051af